import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

const useReportedMaximumAnnualSalesControl = () => {
  const { reportedMaximumAnnualSales } = useRetailerStore([
    "reportedMaximumAnnualSales",
  ]);
  return { reportedMaximumAnnualSales };
};

const useReportedMaximumAnnualSalesTreatment = () => {
  const { retailer } = useRetailer();

  const reportedMaximumAnnualSales = retailer?.annual_sales_max_amount;

  return { reportedMaximumAnnualSales };
};

export const useReportedMaximumAnnualSales = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useReportedMaximumAnnualSalesTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useReportedMaximumAnnualSalesControl();
};
